/* eslint-disable prettier/prettier */
import React from 'react';
import styles from '../../../../styles/components/pageComponents/coach/ProgramCard.module.css';

// Define the shape of our props for full type safety
interface ProgramCardProps {
	programLabel?: string;
	programName?: string;
	completionLabel?: string;
	completionValue?: number; // Expected as a percentage (0-100)
	viewIcon?: React.ReactNode;
	userIcon?: React.ReactNode;
	stats?: {
		label: string;
		value: string | number;
	}[];
	onViewClick?: () => void;
	onUserClick?: () => void;
}

const ProgramCard: React.FC<ProgramCardProps> = ({
	programLabel = 'Program Name',
	programName,
	completionLabel = 'Completion Rate',
	completionValue = 0,
	viewIcon,
	userIcon,
	stats = [],
	onViewClick,
	onUserClick,
}) => {
	return (
		<div className={styles.card}>
			<div className={styles.header}>
				<div className={styles.titleSection}>
					{programLabel && (
						<p className={styles.label}>{programLabel}</p>
					)}
					{programName && (
						<h2 className={styles.title}>{programName}</h2>
					)}
				</div>

				<div className={styles.actionButtons}>
					{viewIcon && (
						<button
							className={styles.iconBtn}
							onClick={onViewClick}
							aria-label="View"
						>
							{viewIcon}
						</button>
					)}
					{userIcon && (
						<button
							className={styles.iconBtn}
							onClick={onUserClick}
							aria-label="Users"
						>
							{userIcon}
						</button>
					)}
				</div>
			</div>

			<div className={styles.progressSection}>
				{completionLabel && (
					<p className={styles.label}>{completionLabel}</p>
				)}
				<div className={styles.progressBarBg}>
					<div
						className={styles.progressBarFill}
						style={{
							width: `${Math.min(Math.max(completionValue, 0), 100)}%`,
						}}
					/>
				</div>
			</div>

			{stats.length > 0 && (
				<div className={styles.statsGrid}>
					{stats.map((stat, index) => (
						<div key={index} className={styles.statItem}>
							<p className={styles.statLabel}>{stat.label}</p>
							<p className={styles.statValue}>{stat.value}</p>
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default ProgramCard;
